import {
  Ability,
  AbilityBuilder,
  ForcedSubject,
  MongoQuery,
  subject
} from '@casl/ability'
import {
  ACTIONS,
  SUBJECTS
} from 'features/ContractsPipelineDetails/Abilities/constants'

export type MyOrganizationCommunityAbilityDataType = {
  uuid: string
  status: string
  businessAccountStatus: string
}

export type Actions = ValueOfObject<typeof ACTIONS>
export type Subjects = ValueOfObject<typeof SUBJECTS>

export type PossibleAbilities = [
  Actions,
  Subjects | (MyOrganizationCommunityAbilityDataType & ForcedSubject<Subjects>)
]

export type Conditions =
  | Record<PropertyKey, number | string | MongoQuery>
  | MongoQuery<Record<PropertyKey, number | string | MongoQuery>>

export type MyOrganizationCommunityAbility = Ability<
  PossibleAbilities,
  Conditions
>

export type MyOrganizationCommunityAbilityBuilder =
  AbilityBuilder<MyOrganizationCommunityAbility>

export const myOrganizationCommunitySubject = (type, object) =>
  subject<Subjects, MyOrganizationCommunityAbilityDataType>(type, { ...object })
